export const taggedInputEnUSTranslations = {
  taggedInputPlaceholder: "Add an email…",
  taggedInputInvalidEmail: "Enter a valid email address.",
  taggedInputDuplicate: "“{{email}}” is already a recipient.",
  taggedInputBlockedDomain:
    "Personal email domains aren’t allowed. Use a work address.",
  taggedInputLimit: "You’ve reached the {{max}}-recipient limit.",
  taggedInputMore: "+{{count}} more",
  taggedInputShowLess: "Show less",
  taggedInputRemove: "Remove {{email}}",
  taggedInputRemoveInvalid: "Remove {{email}}, undeliverable address",
  taggedInputRecipients: "Recipients",
  taggedInputCountNone: "No recipients",
  taggedInputCountOne: "1 recipient",
  taggedInputCountMany: "{{count}} recipients",
  taggedInputAdded: "Added {{email}}. {{total}}.",
  taggedInputAddedMany: "Added {{count}} recipients. {{total}}.",
  taggedInputAddedAll: "Added {{count}} recipients.",
  taggedInputRemoved: "Removed {{email}}. {{total}}.",
  taggedInputListName: "{{label}}: {{total}}",
};
